import React from 'react'
import { ToastContainer } from 'react-toastify'

const RT_NAMESPACE = 'Toastify'

function CloseButton({ closeToast, type, ariaLabel }) {
  return (
    <button
      className={`${RT_NAMESPACE}__close-button ${RT_NAMESPACE}__close-button--${type}`}
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        closeToast(e)
      }}
      aria-label={ariaLabel}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd" stroke="#000" strokeLinejoin="round" strokeWidth="1.2">
          <path d="M12.735 12.735l-9.46-9.46M3.275 12.735l9.46-9.46" />
        </g>
      </svg>
    </button>
  )
}

const Container = () => {
  return (
    <ToastContainer
      autoClose={7000}
      // pauseOnFocusLoss={false}
      // hideProgressBar={true}
      // pauseOnHover={true}
      closeButton={<CloseButton />}
    />
  )
}

export default Container
